module.exports = __webpack_public_path__ + "img/tooltip_05-vallone-noya-29-black.950a0e23.jpg";